import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ReprocessingProgressDialog } from '../components/reprocessing/ReprocessingProgressDialog';

export default function TestReprocessingDialog() {
  const [open, setOpen] = useState(false);
  
  return (
    <div className="p-8">
      <h1 className="text-2xl mb-4">Test Reprocessing Dialog</h1>
      <Button onClick={() => {
        console.log('Button clicked, setting open to true');
        setOpen(true);
      }}>
        Open Dialog
      </Button>
      
      <div>Dialog open state: {open ? 'true' : 'false'}</div>
      
      <ReprocessingProgressDialog
        open={open}
        onOpenChange={setOpen}
        siteId="test-site-id"
        totalPages={10}
      />
    </div>
  );
}